var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H6V14H12V18ZM21 14V12L20 7H4L3 12V14H4V20H14V14H18V20H20V14H21ZM20 4H4V6H20V4Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessC);
export default __webpack_public_path__ + "static/media/BusinessC.8d268624.svg";
export { ForwardRef as ReactComponent };